import React from 'react';

export default class Page5 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>

                        <section>
                            <div className="">

                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Step 3 – Complete the checklist
                                            </div>
                                            <p>Once you have established your values and preferences, you’ve
                                                essentially started to consider what drives you and what you may
                                                enjoy doing. Use the checklist below to identify those aspects
                                                that are important to you, to identify the type of role that may
                                                suit you. If you strongly agree with a statement, give it a
                                                double tick and if you partially agree with a statement give it
                                                a single tick. If you don’t agree with one at all, leave it
                                                blank:</p>

                                            <table
                                                className="ilead_v_sport tablesrink mutitable ilead_v_sport1 dothis_job"
                                                border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th colSpan="3" className="green_curve green_curve1"
                                                        align="left" valign="top" width="50%">Checklist
                                                    </th>
                                                </tr>
                                                <tr className=" ">
                                                    <td className="lightgreen  subheading2bg subtiltereg"
                                                        align="left" valign="top" width="10%">Dimension
                                                    </td>
                                                    <td className="lightgreen  subheading2bg subtiltereg"
                                                        align="left" valign="top" width="50%">Statement
                                                    </td>
                                                    <td className="lightgreen  subheading2bg subtiltereg"
                                                        align="center" valign="top" width="5%">Tick
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="center"
                                                        width="10%" rowSpan="4">
                                                        <div className="">Reward or Recognition</div>
                                                    </td>
                                                    <td className="lightgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">1.</span><span
                                                        style={{width: '85%', float: 'left'}}>I enjoy being rewarded for my efforts.</span>
                                                    </td>


                                                    <td className="lightgreen tablecheckboxpadding-none"
                                                        align="center" valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="IEnjoyBeingRewardedForMyEfforts"
                                                               id="IEnjoyBeingRewardedForMyEfforts"
                                                               checked={pageData?.IEnjoyBeingRewardedForMyEfforts}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="IEnjoyBeingRewardedForMyEfforts" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">2.</span><span
                                                        style={{width: '85%', float: 'left'}}>I have a need to be recognised for my work.</span>
                                                    </td>

                                                    <td align="center"
                                                        className="lightgreen tablecheckboxpadding-none"
                                                        valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="IHaveANeedToBeRecognisedForMyWork"
                                                               id="IHaveANeedToBeRecognisedForMyWork"
                                                               checked={pageData?.IHaveANeedToBeRecognisedForMyWork}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="IHaveANeedToBeRecognisedForMyWork" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">3.</span><span
                                                        style={{width: '85%', float: 'left'}}>I consider my work to be of some benefit.</span>
                                                    </td>

                                                    <td align="center"
                                                        className="lightgreen tablecheckboxpadding-none"
                                                        valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="IConsiderMyWorkToBeOfSomeBenefit"
                                                               id="IConsiderMyWorkToBeOfSomeBenefit"
                                                               checked={pageData?.IConsiderMyWorkToBeOfSomeBenefit}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="IConsiderMyWorkToBeOfSomeBenefit" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">4.</span><span
                                                        style={{width: '85%', float: 'left'}}>I am motivated by financial reward.</span>
                                                    </td>

                                                    <td align="center"
                                                        className="lightgreen tablecheckboxpadding-none"
                                                        valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="IAmMotivatedByFinancialReward"
                                                               id="IAmMotivatedByFinancialReward"
                                                               checked={pageData?.IAmMotivatedByFinancialReward}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="IAmMotivatedByFinancialReward" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="10%" rowSpan="4">
                                                        <div className="">Role Content</div>
                                                    </td>
                                                    <td className="darkgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">5.</span><span
                                                        style={{width: '85%', float: 'left'}}>I have chosen a career in a specific sector or industry.</span>
                                                    </td>

                                                    <td className="darkgreen tablecheckboxpadding-none"
                                                        align="center" valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="IHaveChosenACareerInASpecificSectorOrIndustry"
                                                               id="IHaveChosenACareerInASpecificSectorOrIndustry"
                                                               checked={pageData?.IHaveChosenACareerInASpecificSectorOrIndustry}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="IHaveChosenACareerInASpecificSectorOrIndustry" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="darkgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">6.</span><span
                                                        style={{width: '85%', float: 'left'}}>It’s important that I enjoy the type of work I do.</span>
                                                    </td>

                                                    <td align="center"
                                                        className="darkgreen tablecheckboxpadding-none"
                                                        valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="ItsImportantThatIEnjoyTheTypeOfWorkIDo"
                                                               id="ItsImportantThatIEnjoyTheTypeOfWorkIDo"
                                                               checked={pageData?.ItsImportantThatIEnjoyTheTypeOfWorkIDo}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="ItsImportantThatIEnjoyTheTypeOfWorkIDo" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="darkgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">7.</span><span
                                                        style={{width: '85%', float: 'left'}}>I am motivated by the type of work I do.</span>
                                                    </td>

                                                    <td align="center"
                                                        className="darkgreen tablecheckboxpadding-none"
                                                        valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="IAmMotivatedByTheTypeOfWorkIDo"
                                                               id="IAmMotivatedByTheTypeOfWorkIDo"
                                                               checked={pageData?.IAmMotivatedByTheTypeOfWorkIDo}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="IAmMotivatedByTheTypeOfWorkIDo" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="darkgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">8.</span><span
                                                        style={{width: '85%', float: 'left'}}>I use knowledge I have gained to help me in my role.</span>
                                                    </td>

                                                    <td align="center"
                                                        className="darkgreen tablecheckboxpadding-none"
                                                        valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="IUseKnowledgeIHaveGainedToHelpMeInMyRole"
                                                               id="IUseKnowledgeIHaveGainedToHelpMeInMyRole"
                                                               checked={pageData?.IUseKnowledgeIHaveGainedToHelpMeInMyRole}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="IUseKnowledgeIHaveGainedToHelpMeInMyRole" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="center"
                                                        width="10%" rowSpan="4">
                                                        <div className="">Social Aspects</div>
                                                    </td>
                                                    <td className="lightgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">9.</span><span
                                                        style={{width: '85%', float: 'left'}}>I work to provide for my family.</span>
                                                    </td>

                                                    <td className="lightgreen tablecheckboxpadding-none"
                                                        align="center" valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="IWorkToProvideForMyFamily"
                                                               id="IWorkToProvideForMyFamily"
                                                               checked={pageData?.IWorkToProvideForMyFamily}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="IWorkToProvideForMyFamily" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">10.</span><span
                                                        style={{width: '85%', float: 'left'}}>I enjoy working with others as part of a team.</span>
                                                    </td>

                                                    <td align="center"
                                                        className="lightgreen tablecheckboxpadding-none"
                                                        valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="IEnjoyWorkingWithOthersAsPartOfATeam"
                                                               id="IEnjoyWorkingWithOthersAsPartOfATeam"
                                                               checked={pageData?.IEnjoyWorkingWithOthersAsPartOfATeam}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="IEnjoyWorkingWithOthersAsPartOfATeam" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">11.</span><span
                                                        style={{width: '85%', float: 'left'}}>I feel that the work I do benefits the wider community in some respect.</span>
                                                    </td>

                                                    <td align="center"
                                                        className="lightgreen tablecheckboxpadding-none"
                                                        valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="IFeelThatTheWorkIDoBenefitsTheWiderCommunityInSomeRespect"
                                                               id="IFeelThatTheWorkIDoBenefitsTheWiderCommunityInSomeRespect"
                                                               checked={pageData?.IFeelThatTheWorkIDoBenefitsTheWiderCommunityInSomeRespect}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="IFeelThatTheWorkIDoBenefitsTheWiderCommunityInSomeRespect" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">12.</span><span
                                                        style={{width: '85%', float: 'left'}}>I believe in giving something back to society and I do this through my work.</span>
                                                    </td>

                                                    <td align="center"
                                                        className="lightgreen tablecheckboxpadding-none"
                                                        valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="IBelieveInGivingSomethingBackToSocietyAndIDoThisThroughMyWork"
                                                               id="IBelieveInGivingSomethingBackToSocietyAndIDoThisThroughMyWork"
                                                               checked={pageData?.IBelieveInGivingSomethingBackToSocietyAndIDoThisThroughMyWork}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="IBelieveInGivingSomethingBackToSocietyAndIDoThisThroughMyWork" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="10%" rowSpan="4">
                                                        <div className="">Personal Development</div>
                                                    </td>
                                                    <td className="darkgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">13.</span><span
                                                        style={{width: '85%', float: 'left'}}>Learning and developing is important for me.</span>
                                                    </td>

                                                    <td className="darkgreen tablecheckboxpadding-none"
                                                        align="center" valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="LearningAndDevelopingIsImportantForMe"
                                                               id="LearningAndDevelopingIsImportantForMe"
                                                               checked={pageData?.LearningAndDevelopingIsImportantForMe}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="LearningAndDevelopingIsImportantForMe" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="darkgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">14.</span><span
                                                        style={{width: '85%', float: 'left'}}>I want to develop myself in my current role.</span>
                                                    </td>

                                                    <td align="center"
                                                        className="darkgreen tablecheckboxpadding-none"
                                                        valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="IWantToDevelopMyselfInMyCurrentRole"
                                                               id="IWantToDevelopMyselfInMyCurrentRole"
                                                               checked={pageData?.IWantToDevelopMyselfInMyCurrentRole}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="IWantToDevelopMyselfInMyCurrentRole" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="darkgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">15.</span><span
                                                        style={{width: '85%', float: 'left'}}>I have a career path and am constantly moving towards an overall aim or a set of objectives.</span>
                                                    </td>

                                                    <td align="center"
                                                        className="darkgreen tablecheckboxpadding-none"
                                                        valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="IHaveACareerPathAndAmConstantlyMovingTowardsAnOverallAimOrASetOfObjectives"
                                                               id="IHaveACareerPathAndAmConstantlyMovingTowardsAnOverallAimOrASetOfObjectives"
                                                               checked={pageData?.IHaveACareerPathAndAmConstantlyMovingTowardsAnOverallAimOrASetOfObjectives}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="IHaveACareerPathAndAmConstantlyMovingTowardsAnOverallAimOrASetOfObjectives" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="darkgreen" width="50%"><span
                                                        className="brown boldtext numberpadding tab_span">16.</span><span
                                                        style={{width: '85%', float: 'left'}}>I learn from experience in order to help me in the future.</span>
                                                    </td>

                                                    <td align="center"
                                                        className="darkgreen tablecheckboxpadding-none"
                                                        valign="top" width="5%">
                                                        <input type="checkbox"
                                                               name="ILearnFromExperienceInOrderToHelpMeInTheFuture"
                                                               id="ILearnFromExperienceInOrderToHelpMeInTheFuture"
                                                               checked={pageData?.ILearnFromExperienceInOrderToHelpMeInTheFuture}
                                                               onChange={this.props.handleChangePageData}/>
                                                        <label htmlFor="ILearnFromExperienceInOrderToHelpMeInTheFuture" className="cursor-pointer">&nbsp;</label>
                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page6')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}